import axios from "axios";
import React, { useState, useEffect, useMemo,useRef } from "react";
import DataTable from "react-data-table-component";
import { gregorianToJalali } from "shamsi-date-converter";
import Source from "../../Source";
import AddItemType from "./forms/AddItemType";
import * as XLSX from "xlsx"; // Import the xlsx library
import AddStock from "../../assets/icon/AddStock.png";
import Trash from "../../assets/icon/trash.png";
import pencil from "../../assets/icon/pencil.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Swal from "sweetalert2";
import { showAlert } from "../../warrper";
import EditItemType from "./forms/EditItemType";
// import { FormattedMessage } from "react-intl";
import { FormattedMessage,useIntl } from "react-intl";
import ReactDOMServer from "react-dom/server";
import { useShowAlert  } from "../../warrper";
import Datepicker_Customer from "../forms/Datepicker_customer";
import { NumericFormat } from "react-number-format";


export default function ItemType() {
  const showAlert = useShowAlert(); 
  const [openadd,setopenadd]=useState(false);
  const [records,setRecords]=useState();
  const inputRef=useRef();
  const inputRefEdit=useRef();
    const [exchange, setExchange] = useState([]);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
      const [Date_End, setDate_end] = useState(new Date().toISOString().slice(0, 10));
      const [EndDate, setEndDate] = useState(null);
  const [isNewExchange, setIsNewExchange] = useState(true);

      // const exportToExcel = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(records); // Convert JSON to sheet
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Item Types");
  //   XLSX.writeFile(workbook, "ItemTypes.xlsx"); // File name
  // };
  const [EditItemRow,SetEditItemRow]=useState();
  const [ModelEdit,setModelEdit]=useState(false);
  const EditItem =(row)=>{
    setModelEdit(true);
    SetEditItemRow(row);
  }
  useEffect(()=>{
    const fetchItemtype = async () => {
      const token = localStorage.getItem('access');
      if (!token) return;
      const fetchWithToken = async (token) => {
        try {
          const response = await axios.get(Source.getAddress()+'/api/itemtype', {
            headers: {
              'Authorization': `Bearer ${token}`,
            }
          });
          setRecords(response.data);
        } catch (error) {
          if (error.response && error.response.status === 401) {
            const refreshToken = localStorage.getItem('refresh');
            if (!refreshToken) return;

            try {
              const refreshResponse = await axios.post(Source.getAddress() + '/api/token/refresh', {
                refresh: refreshToken,
              });
              const newAccessToken = refreshResponse.data.access;
              localStorage.setItem('access', newAccessToken);
              await fetchWithToken(newAccessToken);
            } catch (refreshError) {
              console.error('Error refreshing access token:', refreshError);
            }
          } else {
            console.error('Error fetching accounts:', error);
          }
        }
      };

      await fetchWithToken(token);
    };
    fetchItemtype();
  },[]);
  const intl = useIntl(); // استفاده از هوک useIntl برای دسترسی به ترجمه‌ها
  const delete_itemtype = async (id)=>{
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
  
    const result = await swalWithBootstrapButtons.fire({
              title: intl.formatMessage({id:"Are you sure?"})
                     ,
                     text:intl.formatMessage({id:"You won't be able to revert this!"})
                     ,
                     icon: "warning",
                     showCancelButton: true,
                     confirmButtonText: intl.formatMessage({id:"Yes, delete it!"})
                     ,
                     cancelButtonText: intl.formatMessage({id:"No, cancel!"})
                     ,
                     reverseButtons: true,
    });
    if(result.isConfirmed){
    axios.post(Source.getAddress()+'/api/itemtype/'+id,{_method:'delete'},{
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('access')}`,
      }
    })
    .then((res)=>{
      Swal.fire({
        position: "center",
        icon: "success",
        // title: "Item record successfully deleted !",
                    // title: <FormattedMessage id="record successfully deleted!"/>,
                                title: intl.formatMessage({id:"record successfully deleted!"}),
        showConfirmButton: false,
        timer: 600,
      });
      setRecords((prevRecords) =>
        prevRecords.filter((record) => record.id !== id)
      );
    }).catch((err)=>{
      Swal.fire({
        position: "center",
        icon: "error",
        // title: "Item record not deleted",
                                // title: <FormattedMessage id="Something went wrong!"/>,            
                    title: intl.formatMessage({id:"Something went wrong!"}),
        showConfirmButton: false,
        timer: 600,
      });
    })
    }
    else if(result.dismiss === Swal.DismissReason.cancel){
      Swal.fire({
        position: "center",
        icon: "error",
        // text: "Your Item record is safe :)",
                        // text: <FormattedMessage id="Your Item record is safe :)"/>,
                                text:intl.formatMessage({id:"Your record is safe :)"}),
        showConfirmButton: false,
        timer: 600,
      });
    }
  }
  const PDcolumn=[
  
    { name: (<strong
        style={{
          textAlign: "center",
          backgroundColor: "tranceparent",
          width: "100%",
        }}
      >
    <FormattedMessage id="Delete" />
      </strong>),   selector: (row) => (
        <button
          onClick={() => {
            delete_itemtype(row.id);
            // setEdit(row);
            // setUpdate(true);
            // seTtitle('Edit Type Money');
          }}
          style={{
            border: "none",
            backgroundColor: "transparent",
            height: "100%",
          }}
        >
          <img
            height={"15%"}
            width={"15%"}
            src={Trash}
            style={{ backgroundColor: "tranceparent" }}
          />
        </button>
      ) },
      // old items
      { name: (<strong
        style={{
          textAlign: "center",
          backgroundColor: "tranceparent",
          width: "100%",
        }}
      >
                                                      <FormattedMessage id="Edit" />
      </strong>),selector: (row) => (
        <button
          onClick={() => {
            EditItem(row);
            // Edit_item(row);
            // setEdit(row);
            // setUpdate(true);
            // seTtitle('Edit Type Money');
          }}
          style={{
            border: "none",
            backgroundColor: "transparent",
            height: "100%",
          }}
        >
          <img
            height={"20%"}
            width={"20%"}
            src={pencil}
            style={{ backgroundColor: "tranceparent" }}
          />
        </button>
      ) },
      { name:<FormattedMessage id="Mesurment" />    , selector: (row) => row.measuring, sortable: true },
    
      { name:<FormattedMessage id="Name" />    , selector: (row) => row.name, sortable: true },
    
      {
        name:<FormattedMessage id="Photo" />    ,
        cell: (row) => (
          <img
            src={row.picture===null ? AddStock : row.picture}
            alt={row.name}
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
          />
        ),
        sortable: true,
      },
      
      { name:<FormattedMessage id="ID" />    , selector: (row) => row.id, sortable: true 
        ,style: {
          width: "1px",
          minWidth: "1px",
        },
      },
    ];





const columnsDesktop = [
    { name: "Id", selector: (row) => row.id, sortable: true 
      ,style: {
        width: "1px",
        minWidth: "1px",
      },
    },
    {
      name: "Photo",
      cell: (row) => (
        <img
          src={row.picture===null ? AddStock : row.picture}
          alt={row.name}
          style={{ width: "50px", height: "50px", borderRadius: "50%" }}
        />
      ),
      sortable: true,
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Mesurment", selector: (row) => row.measuring, sortable: true },
    { name: (<strong
      style={{
        textAlign: "center",
        backgroundColor: "tranceparent",
        width: "100%",
      }}
    >
      Edit
    </strong>),selector: (row) => (
      <button
        onClick={() => {
          EditItem(row);
          // Edit_item(row);
          // setEdit(row);
          // setUpdate(true);
          // seTtitle('Edit Type Money');
        }}
        style={{
          border: "none",
          backgroundColor: "transparent",
          height: "100%",
        }}
      >
        <img
          height={"20%"}
          width={"20%"}
          src={pencil}
          style={{ backgroundColor: "tranceparent" }}
        />
      </button>
    ) },{ name: (<strong
      style={{
        textAlign: "center",
        backgroundColor: "tranceparent",
        width: "100%",
      }}
    >
      Delete
    </strong>),   selector: (row) => (
      <button
        onClick={() => {
          delete_itemtype(row.id);
          // setEdit(row);
          // setUpdate(true);
          // seTtitle('Edit Type Money');
        }}
        style={{
          border: "none",
          backgroundColor: "transparent",
          height: "100%",
        }}
      >
        <img
          height={"15%"}
          width={"15%"}
          src={Trash}
          style={{ backgroundColor: "tranceparent" }}
        />
      </button>
    ) },
  ];
  const handleAdd=()=>{
    inputRef.current.select();
    setopenadd(true);
  }
  const { formatMessage } = useIntl();
  const localization = {
    pagination: {
        
        rowsPerPage:<FormattedMessage id="AddrowsPerPage"/> , // مثلا: "تعداد ردیف‌ها"
      previous: <FormattedMessage id="previous"/>, // مثلا: "قبلی"
      next: <FormattedMessage id="next"/>, // مثلا: "بعدی"
      page: <FormattedMessage id="page"/>, // مثلا: "صفحه"
    },
    // شما می‌توانید تنظیمات بیشتر برای متون مورد نظر اضافه کنید.
  };
  const columns = useMemo(() => {
    if (
      localStorage.getItem("language") === "pa" ||
      localStorage.getItem("language") === "da"
    ) {
      return PDcolumn.reverse();
    }
    if (isDesktop) {
      return localStorage.getItem("userTokenname") === "admin"
        ? columnsDesktop
        : columnsDesktop;
    }
    return columnsDesktop;
  }, [isDesktop]);

  useEffect(() => {
    axios
      .get(Source.getAddress() + "/api/goldrate", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
        params: { date:Date_End },
      })
      .then((res) => {
        console.log("Rate response:", res);
        if (res.data) {
          setIsNewExchange(true);
          // اگر هیچ نرخ از سرور دریافت نشد، از اطلاعات record استفاده می‌کنیم
          if (records.length > 0) {
            setExchange(records.map((row,idx) => ({ money_id: row.id, from_amount: res.data[idx]?.money_id===row.id ? res.data[idx].from_amount : 0 })));
          }else{
            setExchange(records.map((row) => ({ money_id: row.id, from_amount: 0 })));
          }
        } else {
          setExchange(res.data);
          setIsNewExchange(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [EndDate, records]);

  const handleChange = (e, idx) => {
    const formattedValue = e.target.value;
    const unformattedValue = formattedValue.replace(/,/g, "").replace("$", "");
    
    setExchange(prev => {
      // Make sure prev is an array before trying to spread it
      if (!Array.isArray(prev)) {
        return prev; // or return a default array if appropriate
      }
      
      const newExchange = [...prev];
      if (newExchange[idx]) {
        newExchange[idx] = {
          ...newExchange[idx],
          from_amount: unformattedValue
        };
      }
      return newExchange;
    });
  };
  // تبدیل تاریخ جلالی به میلادی و تنظیم Date_End
  const handle_date_end = (jalaliDate) => {
    if (jalaliDate) {
      const { year, month, day } = jalaliDate;
      // ایجاد یک شیء تاریخ بدون ساعت و دقیقه
      const date = new Date(year, month - 1, day+1);
      // استخراج فرمت YYYY-MM-DD از تاریخ
      const isoDate = date.toISOString().slice(0, 10);
      setDate_end(isoDate);
    }
  };

  const submit = () => {
    // if (!exchange || exchange.length === 0) {
    //   Swal.fire({
    //     position: "top-end",
    //     icon: "error",
    //     title: intl.formatMessage({ id: "No exchange data to submit!" }),
    //     showConfirmButton: false,
    //     timer: 1500,
    //   });
    //   return;
    // }
    // ساخت شیء داده ارسالی شامل تاریخ و نرخ‌ها
    const dataToSend = {
      date: Date_End,
      rates: exchange,
      user_id:localStorage.getItem('userTokenid')
    };

    // console.log(dataToSend);
    // اگر داده‌های اولیه جدید باشند
    if (isNewExchange) {
      axios
        .post(Source.getAddress() + "/api/goldrate", dataToSend, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        })
        .then((res) => {
          showAlert({
            position: "top-end",
            icon: "success",
            title: "Settings updated successfully!",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          showAlert({
            position: "top-end",
            icon: "error",
            title: "Something went wrong!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    } else {
      // به‌روزرسانی نرخ، افزودن متد _method برای ارسال PUT
      // dataToSend._method = "put";
      axios
        .post(Source.getAddress() + "/api/rate", dataToSend, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        })
        .then((res) => {
          // console.log("Exchange updated:", res);
          showAlert({
            position: "top-end",
            icon: "success",
            title: "Settings updated successfully!",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          // console.log(err);
          showAlert({
            position: "top-end",
            icon: "error",
            title: "Something went wrong!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    }
  };


  return (
    <div
      className={`w-100 ${"iransans"} row`}
    >
      <div
                        dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
      className="col-12 col-md-6 mt-4" 
      // style={{ height: "100%" ,width: "100%"}}
      >
      <button
        onClick={handleAdd}
        type="submit"
        className="btn btn-info mb-1 p-1 text-white"
        style={{ width: "100px" }}
      >
        <FormattedMessage id="Add" />
      </button>
        <div
    dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
        className="bg-light d-flex justify-content-lg-betweend-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-center"
          style={{borderTop: "5px solid #4a5cf2"}}
        
        >
          {/* <div className="d-flex  m-auto justify-content-between"> */}
          <h2 className="m-2 fw-bold mb-4"><FormattedMessage id="Item Type" />
          </h2>
            {/* <select
              id=""
              name="gender"
            //   onChange={ChangeUser}
              class="form-select h-50 m-auto"
              style={{ width: "20%" }}
            //   value={select_user}
            >
              <option value={'all users'} selected>All Users</option>
            </select> */}
          {/* </div> */}
          {/* <input
            className="form-control m-2 mb-4"
            // style={{ width: "20%" }}
  style={{ width: "100%", maxWidth: "200px" }}

            // onChange={handleFilter}
            type="search"
            placeholder={formatMessage({ id: "Search" })}
            aria-label="Search"
          /> */}
        </div>

        <DataTable
          columns={columns}
          localization={localization} // ارسال ترجمه‌ها      
          data={records}
          // onRowClicked={handleRowClick}
          striped
          responsive
          highlightOnHover
          pagination
        />
      </div>
      
      <AddItemType
       setRecords={setRecords} records={records} open={openadd} close={()=>{setopenadd(false)}} inputRef={inputRef}
      />
      <EditItemType setRecords={setRecords} records={records}  close={()=>setModelEdit(false)} open={ModelEdit} setModelEdit={setModelEdit} EditItemRow={EditItemRow} SetEditItemRow={setModelEdit} inputRef={inputRefEdit}/>
    </div>
  );
}